import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { FormTextStyles } from "./Form";
import type { Typography } from "./constants";
import { ACTION_SIDEBAR_VIEW_MAP } from "./constants";
import { isTypographyTokenType } from "./typePredicates";

export const TextStyles = () => {
  const actionSidebarView = useBuilderStore(state => state.actionSidebarView);

  const getTypographyToken = (): Typography | null => {
    if (isTypographyTokenType(actionSidebarView)) {
      return ACTION_SIDEBAR_VIEW_MAP[actionSidebarView];
    }

    return null;
  };

  const typographyToken = getTypographyToken();

  if (!typographyToken) {
    return null;
  }

  return (
    <div className="divide-primary h-full w-[23rem] divide-y overflow-y-auto">
      <FormTextStyles typographyToken={typographyToken} />
    </div>
  );
};
